export const ONLY_CURRENT_CLUB = null;
export const NETWORK_CLUB_SELECTION = 'selection';
export const ALL_NETWORK_CLUB_LIST = 'all';
